import { Button, Toast } from "antd-mobile";
import React, { forwardRef, useEffect, useRef, useState } from "react";
import { Description } from "../schema";
import { BaseURL } from "../../constant";
import { Result } from "../../schema";
import instance from "../../util/axios";
import Page from "./Page";

interface VSheetProps {
  workflowTemplateId: string;
  dataId?: string;
}

export default forwardRef(
  ({ workflowTemplateId, dataId }: VSheetProps, ref: any) => {
    const [pageData, setPageData] = useState<
      {
        type: string;
        name?: string;
        fields: Description[];
        title: string;
      }[]
    >();
    const [pageIndex, setPageIndex] = useState<number>(0);
    const [pageMaxSize, setPageMaxSize] = useState<number>(0);
    const [mobileData, setMobileData] = useState<{
      [name: string]: any;
    }>();
    const [dataHiddenStatus, setDataHiddenStatus] = useState<
      {
        [key: string]: boolean;
      }[]
    >();
    const [mobileTitle, setMobileTitle] = useState<{
      [name: string]: string;
    }>();
    useEffect(() => {
      (async () => {
        const mobileDescription = await instance.get<
          {
            type: string;
            name: string;
            fields: { name: string; title: string }[];
            title: string;
          }[]
        >(`/wf/formMobile/pageData`);
        const pcData = await instance.get<
          Result<{
            description: Description[];
            data: { [key: string]: any };
            form: { [key: string]: any };
            details: {
              data: {
                descriptions: Description[];
                data: { [key: string]: any };
              }[];
              descriptions: Description[];
              title: string;
            }[];
          }>
        >(
          `/wf/formMobile/data?workflowTemplateId=${workflowTemplateId}&id=${dataId}`
        );
        mobileDescription.data.forEach((mobileParam) => {
          const fields: Description[] = [];

          if (mobileParam.type === "fields") {
            mobileParam.fields.forEach((mobileName) => {
              pcData.data.Data.description.forEach((pcParam) => {
                if (pcParam.fieldName === mobileName.name) {
                  fields.push(pcParam);
                }
              });
              //手机端字段的别名title
              setMobileTitle((prevState) => {
                const cloned = { ...prevState };
                cloned[mobileName.name] = mobileName.title;
                return cloned;
              });
            });
          }
          if (mobileParam.type === "detail") {
            pcData.data.Data.details.forEach((detailInfo) => {
              //根据明细name，寻找到对应的明细
              if (mobileParam.name !== detailInfo.title) return;
              mobileParam.fields.forEach((mobileName) => {
                detailInfo.descriptions.forEach((pcParam) => {
                  if (pcParam.fieldName === mobileName.name) {
                    fields.push(pcParam);
                  }
                });
                //手机端字段的别名title
                setMobileTitle((prevState) => {
                  const cloned = { ...prevState };
                  cloned[mobileName.name] = mobileName.title;
                  return cloned;
                });
              });
            });
          }

          //写入每页数据
          setPageData((prevState) => {
            if (prevState === undefined)
              return [
                {
                  type: mobileParam.type,
                  name: mobileParam.name,
                  fields: fields,
                  title: mobileParam.title,
                },
              ];
            const cloned = [...prevState];
            cloned.push({
              type: mobileParam.type,
              name: mobileParam.name,
              fields: fields,
              title: mobileParam.title,
            });
            return cloned;
          });
        });
        setPageMaxSize(mobileDescription.data.length);
      })();
    }, [dataId, workflowTemplateId]);
    const pageRef = useRef<any>(null);

    return (
      <div
        style={{
          paddingBottom: "93px",
        }}
      >
        {pageData &&
          pageData.length > 0 &&
          pageData.map((param, index) => (
            <>
              {pageIndex === index && (
                <>
                  <Page
                    key={`page${index}`}
                    ref={pageRef}
                    data={mobileData}
                    mobileTitle={mobileTitle}
                    description={param}
                    hidden={dataHiddenStatus && dataHiddenStatus[index]}
                    onChange={(temp, hiddenTemp, detailsIndex) => {
                      if (hiddenTemp !== undefined) {
                        setDataHiddenStatus((prevState) => {
                          if (prevState === undefined) {
                            return [hiddenTemp];
                          } else {
                            const cloned = [...prevState];
                            cloned[index] = hiddenTemp;
                            return cloned;
                          }
                        });
                      }

                      if (temp !== undefined && Object.keys(temp).length > 0) {
                        setMobileData((prevState) => {
                          const cloned = { ...prevState };
                          if (param.type === "fields") {
                            for (const j of Object.keys(temp)) {
                              temp[j]
                                ? (cloned[j] = temp[j])
                                : delete cloned[j];
                            }
                          }
                          if (
                            param.type === "detail" &&
                            param.name !== undefined &&
                            detailsIndex !== undefined
                          ) {
                            if (cloned[param.name] === undefined)
                              cloned[param.name] = [temp];
                            else if (detailsIndex > cloned[param.name].length)
                              cloned[param.name].push(temp);
                            else cloned[param.name][detailsIndex] = temp;
                          }
                          return cloned;
                        });
                      }
                    }}
                  />
                </>
              )}
            </>
          ))}
        {pageMaxSize && (
          <div style={{ position: "fixed", bottom: 0, width: "100%" }}>
            <Button
              size="large"
              key="up"
              disabled={pageIndex === 0}
              onClick={() => {
                setDataHiddenStatus((prevstate) => {
                  if (prevstate === undefined)
                    return [pageRef.current.dataHiddenStatus()];
                  const cloned = [...prevstate];
                  cloned[pageIndex] = pageRef.current.dataHiddenStatus();
                  return cloned;
                });

                // if (dataHiddenStatus !== undefined) {
                //   pageRef.current?.hidden(dataHiddenStatus[pageIndex - 1]);
                // } else {
                //   console.log("data hidden status undefined", pageIndex);
                // }

                // if (pageIndex !== pageMaxSize - 1) setPageIndex(pageIndex - 1);
                setPageIndex(pageIndex - 1);
              }}
            >
              上一页
            </Button>
            {pageIndex !== pageMaxSize - 1 && (
              <Button
                size="large"
                key="down"
                onClick={() => {
                  if (!pageRef.current.jumpPage()) {
                    Toast.info("请填写必填项", 1);
                    return;
                  }
                  setDataHiddenStatus((prevstate) => {
                    if (prevstate === undefined)
                      return [pageRef.current.dataHiddenStatus()];
                    const cloned = [...prevstate];
                    cloned[pageIndex] = pageRef.current.dataHiddenStatus();
                    return cloned;
                  });
                  setPageIndex(pageIndex + 1);
                }}
              >
                下一页
              </Button>
            )}
            {pageIndex === pageMaxSize - 1 && (
              <Button
                type={"primary"}
                size="large"
                key="save"
                onClick={() => {
                  if (!pageRef.current.jumpPage()) {
                    Toast.info("请填写必填项", 1);
                    return;
                  }
                  let urlParam = "";
                  if (mobileData !== undefined) {
                    for (const i of Object.keys(mobileData)) {
                      if (typeof mobileData[i] !== "object") {
                        urlParam += "&" + i + "=" + mobileData[i];
                      }
                    }
                    for (const i of Object.keys(mobileData)) {
                      if (typeof mobileData[i] !== "object") {
                        delete mobileData[i];
                      }
                    }
                    for (const i of Object.keys(mobileData)) {
                      for (let j = 0; j < mobileData[i].length; j++) {
                        for (const k of Object.keys(mobileData[i][j])) {
                          if (mobileData[i][j][k] === undefined)
                            mobileData[i][j][k] = "";
                        }
                      }
                    }
                  }
                  window.open(
                    BaseURL +
                      `/wf/form/vsheet/form?workflowTemplateId=${workflowTemplateId}&id=0${urlParam}&detailDatas=${encodeURI(
                        JSON.stringify(mobileData)
                      )}`,
                    "收集客户资料"
                  );
                }}
              >
                保存
              </Button>
            )}
          </div>
        )}
      </div>
    );
  }
);
